// extracted by mini-css-extract-plugin
export default {"header":"eventDeatail_header__HENN0","sliderBtn":"eventDeatail_sliderBtn__R+Uds","fadeIn":"eventDeatail_fadeIn__VoxI3","sliderBtnActive":"eventDeatail_sliderBtnActive__m3JJ1"};